import { Fragment } from 'react';
import { Comment } from './Comment';
import { Comment as CommentType } from '~/lib/discussions/types';

export function Children({
  root,
  comments,
  mutateComment,
  moderator = false,
}: {
  root: CommentType;
  comments: CommentType[];
  mutateComment: () => void;
  moderator?: boolean;
}) {
  return (
    <>
      {comments.map((comment) => (
        <Fragment key={comment.id}>
          <Comment
            href={`${root.display_path}#${comment.id}`}
            comment={comment}
            moderator={moderator}
            mutateComment={mutateComment}
            border
            className="mt-10"
          />
          {comment.children && comment.children.length > 0 && (
            <div className="ml-24">
              <Children
                root={root}
                comments={comment.children}
                moderator={moderator}
                mutateComment={mutateComment}
              />
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
}
